export default "__VITE_ASSET__BpGC9G0G__"